import { render } from "./totalincome.vue?vue&type=template&id=4b8feca6"
import script from "./totalincome.vue?vue&type=script&lang=js"
export * from "./totalincome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__